import { Route } from '..';

import { Filter } from '@web/components/ui/view-filters';
import { trpc } from '@web/lib/trpc';
import { BrandDetailsView } from './brand-details-view';
import { useState } from 'react';
import { ViewContainer } from '@web/components/ui/view-container';
import { BrandsTable } from './brands-table';
import { CreateBrandDialog } from './create-brand-dialog';

export function BrandInterface() {
  const navigate = Route.useNavigate();

  const [createBrandDialogOpen, setCreateBrandDialogOpen] =
    useState<boolean>(false);

  const [selectedBrandId, setSelectedBrandId] = useState<string | null>(null);

  const { name } = Route.useSearch();

  const { data: brandsData, refetch: refetchBrandsData } =
    trpc.brand.listAll.useQuery();

  const filteredBrands =
    brandsData?.filter((brand) => {
      if (name && !brand.name.toLowerCase().includes(name.toLowerCase()))
        return false;

      return true;
    }) ?? [];

  const { mutateAsync: deleteBrandMutation } = trpc.brand.delete.useMutation();

  const filters = [
    {
      key: 'name',
      label: 'Name',
      type: 'string',
      value: name,
      isMainFilter: true,
    },
  ] as const satisfies Filter[];

  const onFilterChange = (
    newSearch: Record<string, string | number | boolean | object | undefined>,
  ) => {
    void navigate({
      search: (current) => ({ ...current, ...newSearch }),
    });
  };

  return (
    <div>
      <ViewContainer
        title="Brands"
        addButtonLabel="Add Brand"
        onAddButtonClick={() => {
          setCreateBrandDialogOpen(true);
        }}
        filters={filters}
        onFilterChange={onFilterChange}
      >
        {/* Your table or any other content goes here */}
        <BrandsTable
          brands={filteredBrands}
          onDetails={({ id }) => {
            setSelectedBrandId(id);
          }}
          onDelete={async ({ id }) => {
            await deleteBrandMutation({ id });
            await refetchBrandsData();
          }}
        />
      </ViewContainer>

      {/* Dialog for editing brands */}
      {selectedBrandId !== null && (
        <BrandDetailsView
          brandId={selectedBrandId}
          onClose={() => {
            setSelectedBrandId(null);

            void refetchBrandsData();
          }}
        />
      )}

      {/* Dialog for creating Brands */}
      {createBrandDialogOpen && (
        <CreateBrandDialog
          onClose={() => {
            setCreateBrandDialogOpen(false);
            void refetchBrandsData();
          }}
        />
      )}
    </div>
  );
}
